import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Route } from "react-router-dom";
import { ManagementWidget } from "./ManagementWidget";
export const ManagementRoutes = (props)=>{
    const { state, setState } = props;
    return [
        /*#__PURE__*/ _jsx(Route, {
            exact: true,
            path: "/beheer/reacties",
            render: (_)=>{
                const s0 = state.managementState;
                return ManagementWidget({
                    ...s0
                }).run((s1)=>setState((s0)=>({
                            ...s0,
                            managementState: s1
                        })));
            }
        }, "management/blog-comments")
    ];
};
export const isAuthenticated = ()=>{
    const user = localStorage.getItem("beheer");
    return user ? true : false;
};
